module.exports = __webpack_public_path__ + "static/media/zhengshu3.907ff8a2.jpg";